
const initialState = {
	isLoggedIn: false,	
    username: false,
    token: false,  
    isLoading: false  ,
    is_admin: false,
    can_edit: false,
}

export const UserReducer = (state = initialState, action = {}) => {
   switch (action.type) {
        case 'persist/REHYDRATE':
           return action.payload ? action.payload.UserReducer ? action.payload.UserReducer : state : state;   
        case 'USER_FETCH_DATA_SUCCESS':
        	return {
                ...state,                
                ready_for_code: action.userData.ready_for_code,
                isLoggedIn: action.userData.isLoggedIn,
                token: action.userData.token,
                username: action.userData.username,
                userId: action.userData.userId,
                is_admin: action.userData.is_admin,
                can_edit: action.userData.can_edit,
            };   
        case 'USER_INACTIVE':
        case 'USER_LOGOUT':
          return initialState;     
        case 'USER_IS_LOADING':
            return {
                ...state,
                isLoading: action.boolVisible
            }

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/UserReducer.js